"use strict";

exports.__esModule = true;
exports.default = every;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = (0, _cb.default)(predicate, context);
  var _keys = !(0, _isArrayLike.default)(obj) && (0, _keys2.default)(obj),
    length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}